(function ($, Drupal, rPlayer, Hls) {
  'use strict';

  Drupal.behaviors.PopUp = {
    attach: function (context) {
      $(once('rnal_player_envivo', 'a[data-drupal-link-system-path="taxonomy/term/40467"],.rnal_exploremos_float_sintonizar a,a.rnal_exploremos_header_sintonizar'), context)
        .each(function () {
          $(this).on('click', function (e) {
            e.preventDefault();

            var href = $(this).attr('href');
            let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=760,height=641,left=200,top=100`;
            const newWindow = open(href, 'Radio', params);

            const pollInterval = 100; 
            const maxRetries = 50; 
            let retries = 0;

            const pollForSelectors = setInterval(() => {
              try {
                if (newWindow && newWindow.document) {
                  const emisorasSelect = newWindow.document.querySelector('.rnal_player_stations_live_block_stations_selector_emisoras');
                  const frecuenciasSelect = newWindow.document.querySelector('.rnal_player_stations_live_block_stations_selector_frecuencias');

                  if (emisorasSelect && frecuenciasSelect) {
                    emisorasSelect.value = 'none';
                    frecuenciasSelect.value = 'none';
                    localStorage.removeItem('lastSelectedEmisora');
                    localStorage.removeItem('lastSelectedFrecuencia');

                    clearInterval(pollForSelectors);
                  }
                }
              } catch (err) {
                console.warn('Esperando que el pop-up esté listo...');
              }

              retries++;
              if (retries >= maxRetries) {
                clearInterval(pollForSelectors);
                console.error('El pop-up no está listo o no se detectaron los selectores.');
              }
            }, pollInterval);

            return false;
          });
        });
    },
  };

  Drupal.behaviors.rnalPlayerBodyClass = {
    attach: function (context, settings) {
      if (settings.rplayer) {
        $(once('rnal_player_body_class', 'body'), context)
          .each(function () {
            if (!$(this).hasClass('rnal_player_stations_live_block_body')) {
              $(this).addClass('rnal_player_stations_live_block_body');
            }
          });
      }
    },
  };

  Drupal.behaviors.owlCarouselRnalPlayer = {
    attach: function (context, settings) {
      if (settings.rplayer) {
        $(once('rnal_player_stations_live_block', '.rnal_player_stations_live_block'), context)
          .each(function () {
            $(this).find('.owl-carousel-2x1').each(function () {
              var n = $(this).find('.owl-item-2x1').length;
              $(this).owlCarousel({
                items: 1,
                loop: ((n > 1) ? true : false),
                mouseDrag: ((n > 1) ? true : false),
                margin: 0,
                dots: false,
                touchDrag: true,
                autoplay: true,
                autoplayTimeout: 5000,
                autoplayHoverPause: true,
              });
            });
            $(this).find('.owl-carousel-3x1-min-2').each(function () {
              var n = $(this).find('.owl-item-3x1').length;
              $(this).owlCarousel({
                items: 3,
                loop: ((n > 3) ? true : false),
                touchDrag: ((n > 3) ? true : false),
                mouseDrag: ((n > 3) ? true : false),
                margin: 0,
                dots: false,
              });
            });
            $(this).find('.rnal_player_stations_live_block_related').each(function () {
              $(this).find('.view-content').each(function () {
                $(this).addClass('row');
              });
            });
          });
      }

    },
  };

  $(document).ready(function () {
    jcf.replace('.rnal_player_stations_live_block_live_player_player_slide input');
    var rnalPlayer = new rPlayer();
    rnalPlayer.volume = 0.7;

    $(document).on('click', '.rnal_player_stations_live_block_live_player_player_play_button', function () {
      var hlsSrc = $(this).data('hls');
      if (rnalPlayer.playing) {
        rnalPlayer.stop();
        $(this).removeClass('fa-play-circle');
        $(this).find('i').each(function () {
          $(this).removeClass('fa-pause-circle');
          $(this).addClass('fa-play-circle');
        });
      } else {
        rnalPlayer.playSrc(hlsSrc);
        $(this).addClass('playing');
        $(this).find('i').each(function () {
          $(this).removeClass('playing');
          $(this).addClass('fa-pause-circle');
        });
      }
    });
    $(document).on('click', '.rnal_player_stations_live_block_live_player_player_sound_mute', function () {
      if (!rnalPlayer.muted) {
        rnalPlayer.mute();
        $(this).find('i').each(function () {
          $(this).addClass('fa-volume-mute');
          $(this).removeClass('fa-volume-up');
        });
        $(this).addClass('muted');
      } else {
        rnalPlayer.mute();
        $(this).find('i').each(function () {
          $(this).addClass('fa-volume-up');
          $(this).removeClass('fa-volume-mute');
        });
        $(this).removeClass('muted');
      }
    });
    $(document).on('click', '.rnal_player_stations_live_block_live_player_player_slide', function () {
      $(this).find('input').on('input', function (e) {
        var input = $(this).val();
        rnalPlayer.volume = input / 100;
        var linearGradient = 'linear-gradient(90deg, rgba(255,255,255,1) ' + input + '%, rgba(255,255,255,0.5) ' + input + '%)';
        $(this).parent().find('.jcf-range-wrapper').css('background', linearGradient);
        $('.rnal_player_stations_live_block_live_player_player_sound_mute').find('i').each(function () {
          if (!(input > 0)) {
            $(this).addClass('fa-volume-mute');
            $(this).removeClass('fa-volume-up');
          } else if (!rnalPlayer.muted) {
            $(this).addClass('fa-volume-up');
            $(this).removeClass('fa-volume-mute');
          }
        });
      });
    });
  });

  Drupal.behaviors.rnalLiveSelectors = {
    attach: function (context, settings) {
      const container = once(
        'rnal-player-stations-live-block',
        '.rnal_player_stations_live_block_stations',
        context
      );
  
      if (container.length > 0) {
        const emisorasSelect = container[0].querySelector(
          '.rnal_player_stations_live_block_stations_selector_emisoras'
        );
        const frecuenciasSelect = container[0].querySelector(
          '.rnal_player_stations_live_block_stations_selector_frecuencias'
        );
  
        if (emisorasSelect) {
          const savedEmisora = localStorage.getItem('lastSelectedEmisora');
          if (savedEmisora) {
            emisorasSelect.value = savedEmisora;
          }
        }
        if (frecuenciasSelect) {
          const savedFrecuencia = localStorage.getItem('lastSelectedFrecuencia');
          if (savedFrecuencia) {
            frecuenciasSelect.value = savedFrecuencia;
          }
        }

        const handleSelectChange = (select, otherSelect, storageKey) => {
          select.addEventListener('change', function () {
            const selectedValue = this.value;
              if (selectedValue === 'none') {
              localStorage.removeItem(storageKey);
              return;
            }
  
            localStorage.setItem(storageKey, selectedValue);
  
            if (otherSelect) {
              otherSelect.value = 'none';
              localStorage.removeItem(
                otherSelect.classList.contains(
                  'rnal_player_stations_live_block_stations_selector_emisoras'
                )
                  ? 'lastSelectedEmisora'
                  : 'lastSelectedFrecuencia'
              );
            }
  
            if (selectedValue) {
              window.location.href = selectedValue;
            }
          });
        };
  
        if (emisorasSelect) {
          handleSelectChange(
            emisorasSelect,
            frecuenciasSelect,
            'lastSelectedEmisora'
          );
        }
        if (frecuenciasSelect) {
          handleSelectChange(
            frecuenciasSelect,
            emisorasSelect,
            'lastSelectedFrecuencia'
          );
        }
      }
    },
  }; 

  Drupal.behaviors.resetSelectorsAndRedirect = {
    attach: function (context) {
      

      $(once('reset-selectors', '.otras-emisoras .field-content a', context)).each(function () {
        $(this).on('click', function (e) {
          e.preventDefault();  
       
          const emisorasSelect = document.querySelector('.rnal_player_stations_live_block_stations_selector_emisoras');
          const frecuenciasSelect = document.querySelector('.rnal_player_stations_live_block_stations_selector_frecuencias');
  
          if (emisorasSelect) {
            emisorasSelect.value = 'none';
          }
          if (frecuenciasSelect) {
            frecuenciasSelect.value = 'none';
          }
  
          localStorage.removeItem('lastSelectedEmisora');
          localStorage.removeItem('lastSelectedFrecuencia');
  
          
          window.location.href = $(this).attr('href');  
        });
      });
    }
  };
  

})(jQuery, Drupal, rPlayer, Hls);
